import { render, staticRenderFns } from "./ResidentsSettings.vue?vue&type=template&id=12da6f2d&scoped=true&"
import script from "./ResidentsSettings.vue?vue&type=script&lang=js&"
export * from "./ResidentsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ResidentsSettings.vue?vue&type=style&index=0&id=12da6f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da6f2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VIcon,VPagination,VRow,VSimpleTable,VTooltip})
